import { forwardRef } from 'react';
import { cn } from '../utils/cn';
import styles from './AiButton.module.css';
import type { AiButtonProps } from './AiButton.types';

const AiButton = forwardRef<HTMLButtonElement, AiButtonProps>(
	({ isActive = false, className, children, ...buttonProps }, ref) => {
		return (
			<button
				className={cn(styles.root, isActive && styles.sheen, className)}
				data-testid="ai-button"
				ref={ref}
				type="button"
				{...buttonProps}
			>
				{children}
			</button>
		);
	}
);

export { AiButton };
